export default "__VITE_ASSET__94fb3278__"